export function form() {
  // if (window.document.body.classList.contains('page-id-75') == true) {
  if (window.document.body.classList.contains('page-id-120') == true) {
    const inquireType = document.getElementById("inquireType").textContent;
    const inquire = document.querySelector('.p-form__itemConfirmRadioItem--inquire')
    const recruit = document.querySelector('.p-form__itemConfirmRadioItem--recruit')
    const others = document.querySelector('.p-form__itemConfirmRadioItem--others')
    console.log(inquireType);
    if ( inquireType.includes("お問い合わせ") ) {
      inquire.classList.add("is-active");
    } else if ( inquireType.includes("採用") ) {
      recruit.classList.add("is-active");
    } else if ( inquireType.includes("その他") ) {
      others.classList.add("is-active");
    }
  // } else if (window.document.body.classList.contains('page-id-107') == true) {
  } else if (window.document.body.classList.contains('page-id-122') == true) {
    const inquireType = document.getElementById("inquireTypeEn").textContent;
    const inquire = document.querySelector('.p-form__itemConfirmRadioItem--inquire')
    const recruit = document.querySelector('.p-form__itemConfirmRadioItem--recruit')
    const others = document.querySelector('.p-form__itemConfirmRadioItem--others')
    console.log(inquireType);
    if ( inquireType.includes("Inquiry") ) {
      inquire.classList.add("is-active");
    } else if ( inquireType.includes("Recruit") ) {
      recruit.classList.add("is-active");
    } else if ( inquireType.includes("Other") ) {
      others.classList.add("is-active");
    }
  }
}
